import { createWebHistory, createRouter } from 'vue-router';
import { useAccountStore } from '@/store/AccountStore';
import _ from 'lodash';
const routes = [
  // Public routes
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('@/views/AuthView.vue'),
    meta: {
      requiresAuth: false,
      sidebar: false,
    },
  },
  // {
  //   path: '/registration',
  //   name: 'registration',
  //   component: () => import('@/views/RegView.vue'),
  //   meta: {
  //     requiresAuth: false,
  //     sidebar: false,
  //   },
  // },
  {
    path: '/:pathMatch(.*)*',
    name: 'Error404',
    component: () => import('@/views/404.vue'),
    meta: {
      title: '404 - New Horizons',
      requiresAuth: false,
      sidebar: false,
    },
  },

  // Protected routes
  {
    path: '/',
    name: 'home',
    redirect: '/orders',
  },
  {
    path: '/routes',
    name: 'routes',
    component: () => import('@/views/workspace/routes/RoutesView.vue'),
    meta: {
      requiresAuth: true,
      sidebar: true,
      breadcrumb: 'sidebar.routes',
    },
  },
  {
    path: '/terminal-demo',
    name: 'terminal-demo',
    component: () => import('@/views/tools/TerminalView.vue'),
    meta: {
      requiresAuth: true,
      sidebar: true,
      breadcrumb: 'sidebar.terminal-demo',
    },
  },
  {
    path: '/terminal',
    name: 'terminal',
    component: () => import('@/views/tools/TerminalIframeView.vue'),
    meta: {
      requiresAuth: true,
      sidebar: true,
      model: 'lbc-assistant',
      breadcrumb: 'sidebar.terminal',
    },
  },
  {
    path: '/chat',
    name: 'chat',
    component: () => import('@/views/tools/TerminalIframeView.vue'),
    meta: {
      requiresAuth: true,
      sidebar: true,
      model: 'promtless-oss',
      breadcrumb: 'sidebar.chat',
    },
  },
  {
    path: '/inbox',
    name: '',
    meta: {
      requiresAuth: true,
      sidebar: true,
    },
    children: [
      {
        path: '/inbox/incoming/:mailId?',
        name: 'inbox-incoming',
        component: () => import('@/views/tools/inbox/MailView.vue'),
        meta: {
          requiresAuth: true,
          sidebar: true,
          breadcrumb: 'sidebar.incoming',
        },
      },
      {
        path: '/inbox/overview',
        name: 'inbox-overview',
        component: () => import('@/views/tools/inbox/OpportunitiesRoutesView.vue'),
        meta: {
          requiresAuth: true,
          sidebar: true,
          breadcrumb: 'sidebar.overview',
        },
      },
    ],
  },
  {
    path: '/opportunities',
    name: '',
    meta: {
      requiresAuth: true,
      sidebar: true,
      breadcrumb: 'sidebar.opportunities',
    },
    children: [
      {
        path: '/opportunities/overview',
        name: 'opportunities-overview',
        component: () => import('@/views/automation/opportunities/OpportunitiesView.vue'),
        meta: {
          requiresAuth: true,
          sidebar: true,
          breadcrumb: 'sidebar.overview',
        },
      },
      {
        path: '/opportunities/routes',
        name: 'opportunities-routes',
        component: () => import('@/views/automation/opportunities/RoutesView.vue'),
        meta: {
          requiresAuth: true,
          sidebar: true,
          breadcrumb: 'sidebar.routes',
        },
      },
    ],
  },
  {
    path: '/resources',
    name: '',
    meta: {
      requiresAuth: true,
      sidebar: true,
      breadcrumb: 'sidebar.resources',
    },
    children: [
      {
        path: 'drivers',
        name: 'resource-drivers',
        component: () => import('@/views/workspace/resources/DriverView.vue'),
        meta: {
          requiresAuth: true,
          sidebar: true,
          breadcrumb: 'sidebar.drivers',
        },
      },
      {
        path: 'vehicle',
        name: 'resource-vehicles',
        component: () => import('@/views/workspace/resources/VehicleView.vue'),
        meta: {
          requiresAuth: true,
          sidebar: true,
          breadcrumb: 'sidebar.vehicles',
        },
      },
      {
        path: 'schedules',
        name: 'resource-schedules',
        component: () => import('@/views/workspace/resources/ScheduleView.vue'),
        meta: {
          requiresAuth: true,
          sidebar: true,
          breadcrumb: 'sidebar.schedules',
        },
      },
      {
        path: 'depots',
        name: 'resource-depots',
        component: () => import('@/views/workspace/resources/DepotView.vue'),
        meta: {
          requiresAuth: true,
          sidebar: true,
          breadcrumb: 'sidebar.depots',
        },
      },
      {
        path: 'capabilities',
        name: 'resource-capabilities',
        component: () => import('@/views/workspace/resources/CapabilityView.vue'),
        meta: {
          requiresAuth: true,
          sidebar: true,
          breadcrumb: 'sidebar.capabilities',
        },
      },
      {
        path: 'lineassignments',
        name: 'resource-lineassignments',
        component: () => import('@/views/workspace/resources/LineAssignmentView.vue'),
        meta: {
          requiresAuth: true,
          sidebar: true,
          breadcrumb: 'sidebar.lineAssignments',
        },
      },
      {
        path: 'addresses',
        name: 'resource-addresses',
        component: () => import('@/views/workspace/resources/AddressView.vue'),
        meta: {
          requiresAuth: true,
          sidebar: true,
          breadcrumb: 'sidebar.addresses',
        },
      },
      {
        path: 'operations',
        name: 'resource-operations',
        component: () => import('@/views/workspace/resources/OperationView.vue'),
        meta: {
          requiresAuth: true,
          sidebar: true,
          breadcrumb: 'sidebar.operations',
        },
      },
      {
        path: 'contacts',
        name: 'resource-contacts',
        component: () => import('@/views/workspace/resources/ContactView.vue'),
        meta: {
          requiresAuth: true,
          sidebar: true,
          breadcrumb: 'sidebar.contacts',
        },
      },
    ],
  },
  {
    path: '/articles',
    name: 'articles',
    component: () => import('@/views/workspace/articles/ArticlesView.vue'),
    meta: {
      requiresAuth: true,
      sidebar: true,
      breadcrumb: 'sidebar.articles',
    },
  },
  {
    path: '/orders/:ordernumber?',
    name: 'orders',
    component: () => import('@/views/workspace/orders/OrdersView.vue'),
    meta: {
      requiresAuth: true,
      sidebar: true,
      breadcrumb: 'sidebar.orders',
    },
  },
  {
    path: '/customers',
    name: 'customers',
    component: () => import('@/views/workspace/customers/CustomerView.vue'),
    meta: {
      requiresAuth: true,
      sidebar: true,
      breadcrumb: 'sidebar.customers',
    },
  },
  {
    path: '/suppliers',
    name: 'suppliers',
    component: () => import('@/views/workspace/suppliers/SupplierView.vue'),
    meta: {
      requiresAuth: true,
      sidebar: true,
      breadcrumb: 'sidebar.suppliers',
    },
  },
  {
    path: '/pricelists',
    name: 'pricelists',
    component: () => import('@/views/workspace/pricelists/PricelistView.vue'),
    meta: {
      requiresAuth: true,
      sidebar: true,
      breadcrumb: 'sidebar.pricelists',
    },
  },
  {
    path: '/invoices',
    name: 'invoices',
    component: () => import('@/views/workspace/invoices/InvoiceView.vue'),
    meta: {
      requiresAuth: true,
      sidebar: true,
      breadcrumb: 'sidebar.invoices',
      group: 'workspace',
    },
  },
  {
    path: '/settings',
    name: 'settings',
    meta: {
      requiresAuth: true,
      sidebar: true,
      breadcrumb: 'sidebar.group.settings',
    },
    children: [
      {
        path: 'status',
        name: 'settings-status',
        component: () => import('@/views/settings/SyncStatus.vue'),
        meta: {
          requiresAuth: true,
          sidebar: true,
          breadcrumb: 'sidebar.status',
        },
      },
    ],
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard to check authentication
router.beforeEach(async (to, from, next) => {
  const accountStore = useAccountStore();
  const requiresAuth = to.meta.requiresAuth !== false;
  // If the route does not require authentication, proceed
  if (!requiresAuth) {
    return next();
  }

  // Check if the user is authenticated (only if the path is changing, to avoid redundant checks)
  let isAuthenticated = true;
  if (to.path !== from.path) {
    isAuthenticated = await accountStore.verifyAuthentication();
  }

  // If the route is the Auth page and the user is authenticated, redirect to home
  if (to.name === 'Auth' && isAuthenticated) {
    // If already authenticated, redirect to home
    return next({ name: 'home' });
  }

  // If auth is required and not authenticated, redirect to Auth page
  if (!isAuthenticated) {
    return next({
      name: 'Auth',
      query: { redirect: to.fullPath },
    });
  }
  // If meta.query exists, ensure all keys are in the route query
  if (to.meta && to.meta.query) {
    const missingQuery = Object.entries(to.meta.query).some(([key, _value]) => to.query[key] === undefined);
    if (missingQuery) {
      return next({
        name: to.name,
        params: to.params,
        query: _.merge({}, to.meta.query, to.query),
        replace: true,
      });
    }
  }
  // If authenticated, update user profile and proceed
  await accountStore.updateUserProfile();
  next();
});

router.onError((error, to) => {
  const errorsToRedirect = ['dynamically imported module', 'Importing a module script failed'];
  if (errorsToRedirect.some((msg) => error.message.includes(msg))) {
    window.location.href = to.fullPath;
  }
});
